var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AElf from 'aelf-sdk';
import { createManagerForwardCall, createTransferToken, getAElf, handleTransaction } from '../aelf/index.js';
import { CONTRACT_METHOD_NAME, MANAGER_FORWARD_CALL } from '../constants/index.js';
import { TWalletType } from '@etransfer/types';
export const createTransferTokenTransaction = ({ caContractAddress, eTransferContractAddress, caHash, symbol, amount, chainId, endPoint, fromManagerAddress, walletType, memo, getSignature, }) => __awaiter(void 0, void 0, void 0, function* () {
    let transactionParams;
    if (walletType === TWalletType.NightElf) {
        transactionParams = yield createTransferToken({
            contractAddress: eTransferContractAddress,
            endPoint,
            chainId,
            args: { symbol, amount, memo },
        });
    }
    else {
        if (!caHash)
            throw new Error('User caHash is missing');
        transactionParams = yield yield createManagerForwardCall({
            caContractAddress,
            contractAddress: eTransferContractAddress,
            caHash,
            methodName: CONTRACT_METHOD_NAME.TransferToken,
            args: { symbol, amount, memo },
            chainId,
            endPoint,
        });
    }
    const packedInput = AElf.utils.uint8ArrayToHex(transactionParams);
    const aelf = getAElf(endPoint);
    const { BestChainHeight, BestChainHash } = yield aelf.chain.getChainStatus();
    const transaction = yield handleTransaction({
        blockHeightInput: BestChainHeight,
        blockHashInput: BestChainHash,
        packedInput,
        address: fromManagerAddress,
        contractAddress: walletType === TWalletType.NightElf ? eTransferContractAddress : caContractAddress,
        functionName: walletType === TWalletType.NightElf ? CONTRACT_METHOD_NAME.TransferToken : MANAGER_FORWARD_CALL,
        getSignature,
    });
    console.log('>>>>>> createTransferTokenTransaction transaction', transaction);
    return transaction;
});
